import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AppState } from '../../reducers';
import { DictionaryService } from '../services/dictionary.service';
import { LocaleDefaultChange } from '../store/dictionary.actions';
import { dictionarySelector } from '../store/dictionary.selectors';

export const dictionaryResolver: ResolveFn<boolean | null> = () => {
  const dictionaryService = inject(DictionaryService);
  const store = inject(Store<AppState>);

  const dictionary = store.selectSignal(dictionarySelector)();
  if (dictionary) {
    return of(true);
  }

  return dictionaryService.getLocales().pipe(
    switchMap(locales => {
      const locale = locales?.find(l => l.localedefault) ?? locales?.[0];
      if (!locale) {
        return of(null);
      }
      store.dispatch(new LocaleDefaultChange({ data: locale }));
      return dictionaryService.getDictionary(locale).pipe(map(() => true));
    }),
    catchError(() => of(null))
  );
};
